import { inject, Injectable } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { FormControlValidators } from '@forms';
import { COUNTRY_ISO_NUMBER, TranslateService } from '@i18n';
import { FeatureCheckoutTranslationDictionary } from '../../i18n/feature-checkout-dictionary.interface';
import { ContactDetailsFormField } from '../../models/contact-details/contact-details-form-field.enum';
import { ContactDetailsForm } from '../../models/contact-details/contact-details-form.interface';

@Injectable()
export class ContactDetailsFormBuilder {
  private readonly countryIsoNumber = inject(COUNTRY_ISO_NUMBER);
  private readonly formBuilder = inject(FormBuilder);
  private readonly translateService = inject(
    TranslateService<FeatureCheckoutTranslationDictionary>,
  );
  build(): FormGroup<ContactDetailsForm> {
    return this.formBuilder.group(this.buildFormConfig());
  }

  private buildFormConfig(): ContactDetailsForm {
    return {
      [ContactDetailsFormField.MarketingPreferencePost]: new FormControl(null),
      [ContactDetailsFormField.Email]: new FormControl(
        null,
        Validators.compose([
          FormControlValidators.email(
            this.translateService.translate('CONTACT_DETAILS_FORM_EMAIL_VALID'),
          ),
          FormControlValidators.maximumLength(
            50,
            this.translateService.translate(
              'CONTACT_DETAILS_FORM_EMAIL_MAX_LENGTH',
            ),
          ),
        ]),
      ),
      [ContactDetailsFormField.MarketingPreferenceEmail]: new FormControl(null),
      [ContactDetailsFormField.Phone]: new FormControl(
        null,
        Validators.compose([
          FormControlValidators.telephone(
            this.countryIsoNumber,
            this.translateService.translate('CONTACT_DETAILS_FORM_PHONE_VALID'),
          ),
        ]),
      ),
    };
  }
}
